import {
  createSlice,
  createAsyncThunk,
  createEntityAdapter,
} from '@reduxjs/toolkit';
import axios from 'Services/AxiosService';
import { NC_SEARCH_SIMPLE } from 'store/UrlConstants';

const nonConformiteSearchSimpleAdapter = createEntityAdapter({
  selectId: entity => entity.code
});
const _initialState = nonConformiteSearchSimpleAdapter.getInitialState(
  { status: 'idle' }
);

export const nonConformiteSearchSimple = createAsyncThunk('NonConformites/Search/Simple', async (params, thunkAPI) => {
  const response = await axios.post(NC_SEARCH_SIMPLE, params);
  return response.data;
});

const initialState = {
  ..._initialState,
  lastSearchDerrogationForm: null,
  lastSearchRenseignementsForm: null,
  searchDetails: {},
  searchDetailChips: {},
  tableStates: {},
  renseignementsResultats: [],
  loadingInProgress: false
}

const nonConformiteSearchSlice = createSlice({
  name: 'nonConformiteSearch',
  initialState,
  reducers: {
    setSearchDetail(state, action) {
      const { type, params } = action.payload;
      state.searchDetails[type] = params;
    },
    resetSearchDetail(state) {
      state.searchDetails = {};
    },
    setSearchDetailChips(state, action) {
      const { type, chips } = action.payload;
      state.searchDetailChips[type] = chips;
    },
    resetSearchDetailChips(state) {
      state.searchDetailChips = {};
    },
    resetTableStates(state) {
      state.tableStates = {};
    },
    setTableState(state, action) {
      const { type, tableState } = action.payload;
      state.tableStates[type] = tableState;
    },
    resetTableState(state, action) {
      const type = action.payload;
      if (type) {
        delete state.tableStates[type];
      } else {
        state.tableStates = {};
      }
    },
    setLastSearchDerrogationForm(state, action) {
      state.lastSearchDerrogationForm = action.payload
    },
    setLastSearchRenseignementsForm(state, action) {
      state.lastSearchRenseignementsForm = action.payload
    },
  },
  extraReducers: {
    [nonConformiteSearchSimple.fulfilled]: (state, action) => {
      state.status = 'succeeded';
      state.loadingInProgress = false
      nonConformiteSearchSimpleAdapter.setAll(state, action.payload);
    },
    [nonConformiteSearchSimple.pending]: (state, action) => {
      state.loadingInProgress = true
      state.status = 'loading';
    },
    [nonConformiteSearchSimple.rejected]: (state, action) => {
      state.status = 'failed';
      state.loadingInProgress = false
    },
  },
});

// Selectors
export const selectSearchDetailByType = (state, type) => state.nonConformiteSearch.searchDetails[type] || null;
export const selectSearchDetailChipsByType = (state, type) => state.nonConformiteSearch.searchDetailChips[type] || [];
export const selectTableStateByType = (state, type) => state.nonConformiteSearch.tableStates[type] || null;

export const {
  selectAll: selectAllResults,
  selectById: selectResultById,
} = nonConformiteSearchSimpleAdapter.getSelectors((state) => state.nonConformiteSearch);

export const {
  setSearchDetail,
  resetSearchDetail,
  setSearchDetailChips,
  resetSearchDetailChips,
  setTableState,
  resetTableState,
  resetTableStates,
  setLastSearchDerrogationForm,
  setLastSearchRenseignementsForm
} = nonConformiteSearchSlice.actions;

export default nonConformiteSearchSlice.reducer;
